import PATH_URL from "../../routers/path";

const sidebarMenus = [
  {
    type: "item",
    title: "Dashboard",
    path: PATH_URL.DASHBOARD,
    icon: "dashboard",
    permissions: ["view-dashboard"],
  },
  {
    type: "dropdown",
    id: "settings",
    title: "Pengaturan",
    icon: "master",
    permissions: [
      "view-stores",
      "view-outlets",
      "view-users",
      "view-roles",
      "view-permissions",
      "view-units",
      "view-products",
      "view-materials",
      "view-region",
      "view-activity-logs",
    ],
    children: [
      { title: "Konfigurasi Toko", path: PATH_URL.MASTER_STORES, icon: "store", permissions: ["view-stores"] },
      { title: "Outlet & Cabang", path: PATH_URL.MASTER_OUTLETS, icon: "store", permissions: ["view-outlets"] },
      { title: "Pengguna", path: PATH_URL.MASTER_ACCOUNTS, icon: "user-circle", permissions: ["view-users"] },
      {
        title: "Peran & Hak Akses",
        path: PATH_URL.MASTER_ROLES,
        icon: "user-cog",
        permissions: ["view-roles", "view-permissions"],
      },
      { title: "Riwayat Aktivitas", path: PATH_URL.ACTIVITY_LOG, icon: "list", permissions: ["view-activity-logs"] },
      {
        title: "Kategori",
        path: PATH_URL.MASTER_CATEGORIES,
        icon: "category",
        permissions: ["view-products", "view-materials"],
      },
      {
        title: "Tipe / Jenis",
        path: PATH_URL.MASTER_CATEGORY_TYPES,
        icon: "category",
        permissions: ["view-products", "view-materials"],
      },
      { title: "Satuan", path: PATH_URL.MASTER_UNITS, icon: "list", permissions: ["view-units"] },
      {
        type: "section",
        title: "Data lanjutan",
        children: [
          {
            title: "Hak Akses Detail",
            path: PATH_URL.MASTER_PERMISSIONS,
            icon: "shield",
            permissions: ["view-permissions"],
          },
          // { title: "Provinsi", path: PATH_URL.MASTER_REGEION_PROVINCES, icon: "map", permissions: ["view-region"] },
          // {
          //   title: "Kabupaten / Kota",
          //   path: PATH_URL.MASTER_REGEION_CITIES,
          //   icon: "map",
          //   permissions: ["view-region"],
          // },
          // { title: "Kecamatan", path: PATH_URL.MASTER_REGEION_DISTRICTS, icon: "map", permissions: ["view-region"] },
          // { title: "Kelurahan", path: PATH_URL.MASTER_REGEION_VILLAGES, icon: "map", permissions: ["view-region"] },
        ],
      },
    ],
  },

  { type: "separator" },
  {
    type: "dropdown",
    id: "finance",
    title: "Keuangan",
    icon: "report",
    permissions: [
      "view-cash-bank",
      "view-operational-expenses",
      "view-fixed-assets",
      "view-reports",
      "view-sales-reports",
    ],
    children: [
      { title: "Kas & Bank", path: PATH_URL.CASH_BANK, icon: "wallet", permissions: ["view-cash-bank"] },
      {
        title: "Biaya Operasional",
        path: PATH_URL.OPERATIONAL_EXPENSE,
        icon: "clipboard",
        permissions: ["view-operational-expenses"],
      },
      { title: "Aset & Penyusutan", path: PATH_URL.FIXED_ASSET, icon: "package", permissions: ["view-fixed-assets"] },
      {
        title: "Laporan Penjualan",
        path: PATH_URL.REPORT_INCOME,
        icon: "cash-register",
        permissions: ["view-reports", "view-sales-reports"],
      },
      { title: "Laporan Pembelian", path: PATH_URL.REPORT_EXPENSE, icon: "receipt", permissions: ["view-reports"] },
      // {
      //   title: "Ringkasan Keuangan",
      //   path: PATH_URL.FINANCE,
      //   icon: "dashboard",
      //   permissions: ["view-reports"],
      // },
    ],
  },
  { type: "separator" },
  {
    type: "dropdown",
    id: "materials-stock",
    title: "Material & Stok",
    icon: "package",
    permissions: ["view-materials", "view-stock-opnames", "view-stock-reports", "view-stock-transfers", "view-seller-stocks"],
    children: [
      { title: "Bahan Baku", path: PATH_URL.MATERIAL, icon: "package", permissions: ["view-materials"] },
      {
        title: "Laporan Stok",
        path: PATH_URL.STOCK_REPORT,
        icon: "report",
        permissions: ["view-stock-reports", "view-stock-opnames"],
      },
      {
        title: "Histori Stok",
        path: PATH_URL.STOCK_HISTORY,
        icon: "list",
        permissions: ["view-stock-reports", "view-stock-opnames"],
      },
      { title: "Stok Opname", path: PATH_URL.STOCK_OPNAME, icon: "clipboard", permissions: ["view-stock-opnames"] },
      {
        title: "Transfer Antar Outlet",
        path: PATH_URL.STOCK_TRANSFER,
        icon: "package",
        permissions: ["view-stock-transfers"],
      },
      { title: "Stok Seller", path: PATH_URL.SELLER_STOCK, icon: "package", permissions: ["view-seller-stocks"] },
      {
        title: "Inventori Pintar",
        path: PATH_URL.INVENTORY_INSIGHT,
        icon: "brain",
        permissions: ["view-stock-reports", "view-stock-opnames"],
      },
    ],
  },
  {
    type: "dropdown",
    id: "purchases",
    title: "Pembelian Material",
    icon: "receipt",
    permissions: ["view-purchases", "view-suppliers"],
    children: [
      { title: "Daftar Pembelian", path: PATH_URL.PURCHASE, icon: "receipt", permissions: ["view-purchases"] },
      { title: "Supplier", path: PATH_URL.SUPPLIER, icon: "supplier", permissions: ["view-suppliers"] },
    ],
  },

  { type: "separator" },

  {
    type: "item",
    title: "Produk & Resep",
    path: PATH_URL.PRODUCT,
    icon: "product",
    permissions: ["view-products"],
  },
  {
    type: "item",
    title: "Pelanggan",
    path: PATH_URL.CUSTOMER,
    icon: "users",
    permissions: ["view-customers"],
  },
  {
    type: "item",
    title: "Penjualan",
    path: PATH_URL.SALE,
    icon: "cash-register",
    permissions: ["view-sales", "view-own-sales"],
  },
  { type: "separator" },
  {
    type: "item",
    title: "Kasir / POS",
    path: PATH_URL.POS,
    icon: "device-desktop",
    permissions: ["view-pos"],
  },
  {
    type: "item",
    title: "Akasya AI",
    path: PATH_URL.AI_ASSISTANT,
    icon: "brain",
    permissions: ["view-ai-assistant"],
  },
];

export default sidebarMenus;
